import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { KeycloakService } from 'keycloak-angular';
import { Subscription } from 'rxjs';
import { ModalComponent } from 'src/app/components/modal/modal.component';
import { ProfileImageComponent } from 'src/app/components/profile-image/profile-image.component';
import * as myGlobals from 'src/app/globals';
import { GroupShare, GroupShareResult, UserShare, UserShareResult } from 'src/app/models/modal.model';
import { UserAndGroup, UserAndGroupListModel } from 'src/app/models/share-modal.model';
import { MyStorageService } from 'src/app/pages/storage/storage.service';
import { AuthStore } from 'src/app/services/auth.store';
import { CommonService } from 'src/app/services/common.service';
import { NotificationService } from 'src/app/services/notification.service';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import * as SgeCrypto from 'src/assets/lib/sge/sge-crypto';

import { ShareModalService } from './share-modal.service';

@Component({
  selector: 'app-share-modal',
  standalone: true,
  imports: [CommonModule, ModalComponent, FormsModule, ProfileImageComponent, ReactiveFormsModule, TranslateModule],

  providers: [ShareModalService, MyStorageService],
  templateUrl: './share-modal.component.html',
  styleUrls: ['./share-modal.component.scss'],
})
export class ShareModalComponent implements OnChanges {
  @Input() selectedItem: any;
  @ViewChild('inputRef') inputRef!: ElementRef;
  @ViewChild('modalContainer') modalContainer!: ElementRef;
  @ViewChild('btnRef') btnRef!: ElementRef;

  subscription: Subscription = new Subscription();
  userImageUrls: { [userId: string]: string } = {};

  //string
  modalId = 'firstShare';
  shareNote = '';
  searchValue = '';
  searchTerm = '';
  objectId!: string;
  encryptedId!: string;
  parentEncryptedId!: string;
  objectIdList: string[] = [];
  encryptedIdList: string[] = [];

  //boolean
  isShared = false;
  showAutocomplete = false;
  showError = false;
  encryptedItem = false;
  multipleObject = false;
  hasRtukUrl = myGlobals.Config.hasRtukUrl;

  //
  sharedItem: UserAndGroup[] = [];
  mergedArray: any[] = [];

  removedItems: UserAndGroupListModel[] = [];
  updatedItems: any[] = [];
  autocompleteOptions: UserAndGroup[] = [];
  items_: any[] = [];

  constructor(
    private authStore: AuthStore,
    public commonService: CommonService,
    private kcService: KeycloakService,
    private notificationService: NotificationService,
    private shareModalService: ShareModalService,
    private myStorageService: MyStorageService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedItem && this.selectedItem) {
      this.objectId = this.selectedItem.objectId;
      this.encryptedItem = this.selectedItem.encrypted;
      this.encryptedId = this.selectedItem.encryptedId;
      this.parentEncryptedId = this.selectedItem.parentEncryptedId;
    }
  }

  onInputChanges(): void {
    if (this.searchTerm.length >= 1) {
      this.shareModalService.getUserGroupLists(this.searchTerm).subscribe({
        next: (res) => {
          this.sharedItem = res.content;
          this.autocompleteOptions = res.content;
          this.showAutocomplete = this.autocompleteOptions.length > 0 && this.searchTerm.length >= 1;
        },
        error: () => {
          this.sharedItem = [];
        },
      });
    } else {
      this.autocompleteOptions = [];
    }
  }

  onOptionSelected(option: any): void {
    this.searchValue = option;
    const targetItem = this.sharedItem.find((item) => item === option);
    this.onEnterObject(targetItem);
    this.showAutocomplete = false;
    this.searchValue = '';
    this.searchTerm = '';
    this.autocompleteOptions = [];
  }

  closeModal(): void {
    this.btnRef.nativeElement.click();
    this.commonService.setOpenedModalId('');
  }

  onEnterObject(value: any): void {
    if (!value.user) {
      if (!this.items_.map((item) => item.groupId).includes(value.groupId)) {
        const group = {
          shareTarget: value.groupId,
          groupName: value.groupName,
          targetType: 'GROUP_SHARE',
          user: false,
          image: value.image,
          permission: 'VIEW',
          userCount: value.userCount,
          imageId: value.imageId,
        };
        const isGroupExists = this.items_.some((item) => item.shareTarget === value.groupId);

        if (!isGroupExists) this.items_.push(group);

        this.showError = false;
      }
    } else if (value && this.commonService.isEmail(value.email)) {
      if (!this.items_.map((item) => item.shareTarget).includes(value.shareTarget)) {
        const user = {
          shareTarget: value.email,
          firstName: value.firstName,
          user: true,
          image: value.image,
          lastName: value.lastName,
          targetType: 'USER_SHARE',
          permission: 'VIEW',
          imageId: value.imageId,
        };
        const isUserExists = this.items_.some((item) => item.shareTarget === value.email);

        if (!isUserExists) this.items_.push(user);

        this.showError = false;
      } else {
        return;
      }
    }
  }

  addUser(): void {
    this.showAutocomplete = true;
    this.autocompleteOptions = this.sharedItem;
    if (this.searchValue.trim() === '' && this.sharedItem.length <= 0) {
      this.showAutocomplete = false;
    }
  }

  addToObjectIdList(objectId: string): void {
    if (!this.objectIdList.includes(objectId)) {
      this.objectIdList.push(objectId);
    }
  }

  addToEncrpytedIdList(encryptedId: string): void {
    if (!this.encryptedIdList.includes(encryptedId)) {
      this.encryptedIdList.push(encryptedId);
    }
  }

  sendSharedTargetList(): void {
    this.addToObjectIdList(this.objectId);
    const newArray = this.items_.map((item) => ({
      note: item.note,
      permission: item.permission,
      shareTarget: item.shareTarget,
      targetType: item.targetType,
    }));
    const param = {
      name: null,
      objectIds: this.objectIdList,
      privateShareTargetDtos: newArray,
    };
    this.shareModalService.sendShareList(param).subscribe({
      next: (res: any) => {
        let notificationMessage = '';
        if (res.successList.length > 0 && res.failList.length === 0) {
          this.isShared = false;
          this.objectIdList = [];
          this.items_ = [];
          const notification = {
            message: this.commonService.getTranslatedMessage('FILE_SHARE_SUCCESSFUL'),
          };
          this.notificationService.successNotification(notification);
          this.commonService.rebindListener.next();
        }
        if (res.successList.length === 0 && res.failList.length > 0) {
          if (res.failList[0].cause === 'IT_CANNOT_BE_SHARED_WITH_A_GROUP_WHOSE_ONLY_MEMBER_IS_ITSELF') {
            notificationMessage = this.commonService.getTranslatedMessage('IT_CANNOT_BE_SHARED_WITH_A_GROUP_WHOSE_ONLY_MEMBER_IS_ITSELF');
          } else notificationMessage = this.commonService.getTranslatedMessage('ERROR_OCCURRED_DURING_SHARING');
          this.notificationService.errorNotification({ message: notificationMessage });
        }
      },
      complete: () => {
        this.items_ = [];
        this.selectedItem = [];
        this.searchTerm = '';
        this.objectIdList = [];
        this.commonService.handleMultiChoice(undefined);
      },
    });
  }

  onSubmit_(event: Event): void {
    event.preventDefault();
    this.showAutocomplete = false;
    this.isShared = true;
    this.objectIdList.push(this.objectId);
    if (this.searchValue.trim() === '' && this.items_.length <= 0) {
      this.showError = true;
      this.objectIdList = [];
      this.isShared = false;
    } else if (this.items_.length > 0) {
      this.items_.forEach((item) => {
        item.note = this.shareNote || '';
        this.isShared = true;
        this.closeModal();
      });
      this.sendSharedTargetList();
      this.shareNote = '';
      this.items_ = [];
      this.autocompleteOptions = [];
      this.searchValue = '';
      this.searchTerm = '';
      this.showError = false;
    } else if (this.searchValue.trim() !== '' && this.items_.length <= 0) {
      this.isShared = false;
      this.objectIdList = [];
    } else {
      return;
    }
  }

  async encryptedSubmit(event: Event): Promise<void> {
    event.preventDefault();
    this.showAutocomplete = false;
    this.isShared = true;
    this.objectIdList.push(this.objectId);
    if (this.items_.length > 0) {
      if (this.items_.length > 0) {
        this.items_.forEach((item) => {
          item.note = this.shareNote || '';
        });
      }
      const users = this.items_.filter((user) => user.user === true);
      const groups = this.items_.filter((group) => group.user === false);
      const sharedEncryptRegisteredUsers: any[] = [];
      const sendedEncryptRegisteredUsers: any[] = [];
      const sharedEncryptNotRegisteredUsers: any[] = [];
      const sharedEncryptRegisteredGroups: any[] = [];
      const sendedEncryptRegisteredGroups: any[] = [];
      const sharedEncryptNotRegisteredGroups: any[] = [];

      if (this.searchValue.trim() === '' && this.items_.length <= 0) {
        this.showError = true;
        this.isShared = false;
      } else {
        if (users.length > 0) {
          for (const item of users) {
            const isRegistered: boolean = await SgeCrypto.isRegisteredToSecureStorage(item.shareTarget.trim());
            if (isRegistered) {
              sharedEncryptRegisteredUsers.push({
                shareTarget: item.shareTarget,
                permission: item.permission,
                note: item.note,
                targetType: item.targetType,
              });
              if (sharedEncryptRegisteredUsers.length > 0) {
                sendedEncryptRegisteredUsers.push({
                  email: item.shareTarget,
                  permission: item.permission,
                  note: item.note,
                });
              }
            } else {
              sharedEncryptNotRegisteredUsers.push({
                shareTarget: item.shareTarget,
                permission: item.permission,
              });
            }
          }
        }

        if (groups.length > 0) {
          for (const groupShare of groups) {
            const token = await this.kcService.getToken();
            const members: any = await SgeCrypto.getTeamMembers(token, groupShare.shareTarget);
            const memberIndex = members.findIndex((member: { registeredToSecureStorage: boolean }) => member.registeredToSecureStorage === false);
            if (memberIndex >= 0) {
              sharedEncryptNotRegisteredGroups.push({
                shareTarget: groupShare.groupName,
                permission: groupShare.permission,
              });
            } else {
              sharedEncryptRegisteredGroups.push({
                shareTarget: groupShare.shareTarget,
                permission: groupShare.permission,
                note: groupShare.note,
                targetType: groupShare.targetType,
              });
              sendedEncryptRegisteredGroups.push({
                teamId: groupShare.shareTarget,
                permission: groupShare.permission,
                note: groupShare.note,
              });
            }
          }
        }
      }
      this.sendEncryptedSharedTargetList(
        sharedEncryptRegisteredGroups,
        sharedEncryptRegisteredUsers,
        sharedEncryptNotRegisteredUsers,
        sharedEncryptNotRegisteredGroups,
        sendedEncryptRegisteredUsers,
        sendedEncryptRegisteredGroups,
      );
    } else {
      this.showError = true;
    }
  }

  transformShareItem(shareItem: GroupShare | UserShare): UserShareResult | GroupShareResult {
    if (shareItem.targetType === 'USER_SHARE') {
      // Eğer targetType 'USER_SHARE' ise, uygun şekilde dönüştür
      const userShareItem: UserShareResult = {
        email: shareItem.targetId,
        permission: shareItem.permission,
      };

      return userShareItem;
    } else if (shareItem.targetType === 'GROUP_SHARE') {
      // Eğer targetType 'GROUP_SHARE' ise, uygun şekilde dönüştür
      const groupShareItem: GroupShareResult = {
        teamId: shareItem.targetId,
        permission: shareItem.permission,
      };

      return groupShareItem;
    } else {
      // Eğer başka bir durum varsa, varsayılan bir değer döndürün
      return {} as UserShareResult | GroupShareResult;
    }
  }

  transformNotShareItem(shareItem: GroupShare | UserShare): UserShareResult | GroupShareResult {
    if (shareItem.targetType === 'USER_SHARE') {
      const notUserShareItem: UserShareResult = {
        email: shareItem.targetId,
        cause: shareItem.cause,
      };

      return notUserShareItem;
    } else if (shareItem.targetType === 'GROUP_SHARE') {
      const notGroupShareItem: GroupShareResult = {
        teamId: shareItem.targetId,
        cause: shareItem.cause,
      };

      return notGroupShareItem;
    } else {
      return {} as UserShareResult | GroupShareResult;
    }
  }

  addMultipleFalseToEncryptedSubmit(array: any): any {
    return array.map((item: any) => ({ ...item, multiple: false }));
  }

  sendEncryptedSharedTargetList(
    sharedGroups: any,
    sharedUsers: any,
    unSharedUsers: any,
    unSharedGroups: any,
    sendedEncryptRegisteredUsers: any,
    sendedEncryptRegisteredGroups: any,
  ): void {
    const unSharedTargetUsers: any[] = [];
    const unSharedTargetGroups: any[] = [];
    let htmlMessage = '';
    if (this.commonService.getObjectLength(sharedGroups) > 0 && this.commonService.getObjectLength(sharedUsers) > 0) {
      this.mergedArray = sharedGroups.concat(sharedUsers);
    }
    if (this.commonService.getObjectLength(sharedUsers) > 0 && this.commonService.getObjectLength(sharedGroups) === 0) {
      this.mergedArray = sharedUsers;
    }
    if (this.commonService.getObjectLength(sharedGroups) > 0 && this.commonService.getObjectLength(sharedUsers) === 0) {
      this.mergedArray = sharedGroups;
    }

    this.addToObjectIdList(this.objectId);
    const param = {
      name: null,
      objectIds: this.objectIdList, // [{ shareTarget: 'hatice.alkayam@tubitak.gov.tr', permission: 'VIEW', note: undefined, targetType: 'USER_SHARE' }]
      privateShareTargetDtos: this.mergedArray,
    };
    this.shareModalService.sendShareList(param).subscribe({
      next: (res: any) => {
        const userShareArray: UserShareResult[] = [];
        const groupShareArray: GroupShareResult[] = [];
        const failUsers: UserShareResult[] = [];
        const failGroups: GroupShareResult[] = [];

        if (res.successList && res.successList.length > 0) {
          res.successList.forEach((shareItem: any) => {
            const transformedItem = this.transformShareItem(shareItem);

            if ('email' in transformedItem) {
              userShareArray.push(transformedItem);
            } else if ('teamId' in transformedItem) {
              groupShareArray.push(transformedItem);
            }
          });
        }
        const updatedUserArray = this.addMultipleFalseToEncryptedSubmit(userShareArray);
        const updatedGroupArray = this.addMultipleFalseToEncryptedSubmit(groupShareArray);
        if (res.failList && res.failList.length > 0) {
          res.failList.forEach((notShareItem: any) => {
            const transformedItem = this.transformNotShareItem(notShareItem);
            if ('email' in transformedItem) {
              failUsers.push(transformedItem);
            }
            if ('teamId' in transformedItem) {
              failGroups.push(transformedItem);
            }
          });
        }
        this.isShared = false;
        this.kcService.getToken().then((token) => {
          SgeCrypto.createSharing(token, this.parentEncryptedId, [res.encryptedId], null, updatedUserArray, updatedGroupArray)
            .then(() => {
              const handleUnshared = (elements: any[], targetElements: any[], errorMessage: string): void => {
                elements.forEach((element: any) => {
                  if (!targetElements.includes(element.shareTarget)) {
                    targetElements.push(element.shareTarget);
                  }
                });
                const notFound = targetElements.join(', ');
                htmlMessage += errorMessage + '\n' + notFound;
              };

              if (userShareArray.length === 0 || groupShareArray.length === 0) {
                if (unSharedUsers.length > 0 || unSharedGroups.length > 0) {
                  if (unSharedUsers.length > 0) {
                    handleUnshared(unSharedUsers, unSharedTargetUsers, this.commonService.getTranslatedMessage('SHARING_COULD_NOT_BE_DONE'));
                  }
                  if (unSharedGroups.length > 0) {
                    handleUnshared(unSharedGroups, unSharedTargetGroups, this.commonService.getTranslatedMessage('GROUPS_INCLUDE_USERS_NOT_REGISTERED_ENCRYPTED_STORAGE'));
                  }

                  const notification = { message: htmlMessage };
                  this.notificationService.errorNotification(notification);
                }
              }

              if (userShareArray.length > 0 || groupShareArray.length > 0) {
                htmlMessage = this.commonService.getTranslatedMessage('FILE_SHARE_SUCCESSFUL');
                if (sendedEncryptRegisteredGroups.length === 1 && this.commonService.getObjectLength(sendedEncryptRegisteredGroups) === 1)
                  handleUnshared(unSharedGroups, unSharedTargetGroups, '');
                if (unSharedUsers.length > 0 || unSharedGroups.length > 0) {
                  if (unSharedUsers.length > 0) {
                    handleUnshared(unSharedUsers, unSharedTargetUsers, this.commonService.getTranslatedMessage('SHARING_COULD_NOT_BE_DONE'));
                  }
                  if (unSharedGroups.length > 0) {
                    handleUnshared(unSharedGroups, unSharedTargetGroups, this.commonService.getTranslatedMessage('GROUPS_INCLUDE_USERS_NOT_REGISTERED_ENCRYPTED_STORAGE'));
                  }
                  const notification = { message: htmlMessage };
                  this.notificationService.errorNotification(notification);
                } else {
                  const notification = { message: htmlMessage };
                  this.notificationService.successNotification(notification);
                }
                this.commonService.rebindListener.next();
              }
              this.closeModal();
            })
            .catch(() => {
              const notification = {
                message: this.commonService.getTranslatedMessage('ERROR_OCCURRED_DURING_SHARING'),
              };
              this.notificationService.errorNotification(notification);
            });
        });
      },
      complete: () => {
        this.searchTerm = '';
        this.items_ = [];
        this.selectedItem = [];
        this.objectIdList = [];
        this.commonService.handleMultiChoice(undefined);
      },
    });
  }

  closeModalButtonTrigger(): void {
    this.searchValue = '';
    this.searchTerm = '';
    this.shareNote = '';
    this.showError = false;
    this.items_ = [];
    this.btnRef.nativeElement.click();
    this.showAutocomplete = false;
  }

  changePermission(item: any): void {
    this.checkIfItemIncludes(item);
  }

  checkIfItemIncludes(item: any): void {
    const ids = this.updatedItems.map((i) => i.id);
    if (!ids.includes(item.id)) {
      this.updatedItems.push(item);
    }
  }

  removeItem_(item: any): void {
    this.removedItems.push(item);
    this.items_ = this.items_.filter((i) => i.shareTarget !== item.shareTarget);
  }

  removeItems(items: any[]): void {
    items.splice(0, items.length);
  }

  isAcceptedDomain(value: string): boolean {
    return !!(value && value.endsWith('@tubitak.gov.tr'));
  }

  onEnterInputArea(): void {
    this.inputRef.nativeElement.value = '';
    this.searchTerm = '';
    this.onInputChanges();
  }

  getGroupName(group: any): string {
    return group.name;
  }
}
